// extracted by mini-css-extract-plugin
export default {"header":"header_header__H0MYE","sticky":"header_sticky__4IUND"};